export const salesActionsFields = `
  id
  createdById
  label
  name
  personal
  singleUse
  url
`;
